import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AtSign,
  Bold,
  Code,
  FolderCog,
  FolderInput,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Italic,
  Link,
  List,
  ListOrdered,
  Maximize2,
  Minimize2,
  Paperclip,
  Quote,
  Redo2,
  SquareCode,
  Strikethrough,
  Underline,
  Undo2,
  Unlink,
  WandSparkles,
} from "lucide-react";

// Toolbar descriptors, in render order. `kind` tells ToolbarPlugin which
// active-state slice to read and which command to dispatch; `value` is the
// argument for that command.
// Toolbar groups, in render order, separated by a divider. `kind` tells
// ToolbarPlugin which active-state slice to read and which command to
// dispatch; `value` is the argument for that command.
//
// `shortcut` holds display tokens for the tooltip chip and aria-keyshortcuts.
// `bindShortcut` additionally marks the controls whose key ToolbarPlugin must
// register itself; the controls that carry `shortcut` alone (bold, italic,
// underline, link, undo, redo) are already bound by Lexical or LinkDialogPlugin.
export const TOOLBAR_GROUPS = [
  [
    {
      id: "h1",
      label: "Heading 1",
      icon: Heading1,
      kind: "heading",
      value: "h1",
      shortcut: ["mod", "alt", "1"],
      bindShortcut: true,
    },
    {
      id: "h2",
      label: "Heading 2",
      icon: Heading2,
      kind: "heading",
      value: "h2",
      shortcut: ["mod", "alt", "2"],
      bindShortcut: true,
    },
    {
      id: "h3",
      label: "Heading 3",
      icon: Heading3,
      kind: "heading",
      value: "h3",
      shortcut: ["mod", "alt", "3"],
      bindShortcut: true,
    },
    {
      id: "h4",
      label: "Heading 4",
      icon: Heading4,
      kind: "heading",
      value: "h4",
      shortcut: ["mod", "alt", "4"],
      bindShortcut: true,
    },
  ],
  [
    {
      id: "bold",
      label: "Bold",
      icon: Bold,
      kind: "format",
      value: "bold",
      shortcut: ["mod", "B"],
    },
    {
      id: "italic",
      label: "Italic",
      icon: Italic,
      kind: "format",
      value: "italic",
      shortcut: ["mod", "I"],
    },
    {
      id: "underline",
      label: "Underline",
      icon: Underline,
      kind: "format",
      value: "underline",
      shortcut: ["mod", "U"],
    },
    {
      id: "strikethrough",
      label: "Strikethrough",
      icon: Strikethrough,
      kind: "format",
      value: "strikethrough",
      shortcut: ["mod", "shift", "X"],
      bindShortcut: true,
    },
    {
      id: "code",
      label: "Code",
      icon: Code,
      kind: "format",
      value: "code",
      shortcut: ["mod", "E"],
      bindShortcut: true,
    },
  ],
  [
    { id: "quote", label: "Blockquote", icon: Quote, kind: "quote" },
    {
      id: "ul",
      label: "Unordered List",
      icon: List,
      kind: "list",
      value: "bullet",
      shortcut: ["mod", "shift", "8"],
      bindShortcut: true,
    },
    {
      id: "ol",
      label: "Ordered List",
      icon: ListOrdered,
      kind: "list",
      value: "number",
      shortcut: ["mod", "shift", "7"],
      bindShortcut: true,
    },
    {
      id: "codeblock",
      label: "Code Block",
      icon: SquareCode,
      kind: "codeBlock",
    },
  ],
  [
    {
      id: "align-left",
      label: "Align Left",
      icon: AlignLeft,
      kind: "align",
      value: "left",
    },
    {
      id: "align-center",
      label: "Align Center",
      icon: AlignCenter,
      kind: "align",
      value: "center",
    },
    {
      id: "align-right",
      label: "Align Right",
      icon: AlignRight,
      kind: "align",
      value: "right",
    },
    {
      id: "align-justify",
      label: "Justify",
      icon: AlignJustify,
      kind: "align",
      value: "justify",
    },
  ],
  [
    {
      id: "undo",
      label: "Undo",
      icon: Undo2,
      kind: "undo",
      shortcut: ["mod", "Z"],
    },
    {
      id: "redo",
      label: "Redo",
      icon: Redo2,
      kind: "redo",
      shortcut: ["mod", "shift", "Z"],
    },
  ],
  [
    {
      id: "link",
      label: "Add Link",
      icon: Link,
      kind: "addLink",
      shortcut: ["mod", "K"],
    },
    { id: "unlink", label: "Remove Link", icon: Unlink, kind: "removeLink" },
    { id: "mention", label: "Mention a user", icon: AtSign, kind: "mention" },
    {
      id: "attach",
      label: "Attach files",
      icon: Paperclip,
      kind: "attach",
      noteOnly: true,
    },
    {
      id: "template",
      label: "Insert template",
      icon: WandSparkles,
      kind: "template",
      noteOnly: true,
    },
    {
      id: "category",
      label: "Set category",
      icon: FolderInput,
      kind: "category",
      noteOnly: true,
    },
    {
      id: "manageCategories",
      label: "Manage categories",
      icon: FolderCog,
      kind: "manageCategories",
      noteOnly: true,
    },
    {
      id: "fullscreen",
      label: "Full screen",
      icon: Maximize2,
      activeIcon: Minimize2,
      activeTooltip: "Exit full screen",
      kind: "fullscreen",
      noteOnly: true,
    },
  ],
];
